export const __DEV__ = false;
//# sourceMappingURL=index.production.js.map